
import { defineComponent, ref } from 'vue';
import InputText from '@/components/input/InputText.vue';
import InputImage from '@/components/input/InputImage.vue';
import InputCheckbox from '../input/InputCheckbox.vue';
import { useStore } from 'vuex';
import { POST_MEMBER, PUT_MEMBER } from "@/store/member.module";

export default defineComponent({
  components: {
    InputText,
    InputImage,
    InputCheckbox,
  },
  props: {
    title: {
      type: String,
      required: true
    },
    id:{
      type: String,
      required: false
    },
    data: {
      type: Object,
      required: false,
      default: () => ({}) // Provide a default object to prevent undefined errors
    }
  },
  setup(props, { emit }) {
    const store = useStore();
    const modalContent = ref(null);
    const isLoading = ref(false);

    const closeModal = () => {
      isLoading.value = false;
      emit('close');
    };

    const formData = {
      id: '',
      data: {} as Record<string, any>
    }

    const updateValue = (params: { key: string; value: any }) => {
      formData.data[params.key] = params.value;
    };

    const handleSubmit = async () => {
      isLoading.value = true;
      try {
        if(props?.id){
          formData.id = props?.id
          await store.dispatch(PUT_MEMBER, formData);
        }else{
          await store.dispatch(POST_MEMBER, formData);
        }
        closeModal();
      } catch (error:any) {
        alert(error?.response?.data?.message);
        isLoading.value = false;
      }
    };

    return {
      modalContent,
      closeModal,
      handleSubmit,
      updateValue,
      isLoading
    };
  },
});
